const FeatureCard = ({ icon: Icon, title, description }) => {
  return (
    <div className="bg-[#f7f8f7] rounded-2xl p-8 flex flex-col items-start text-left gap-4 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-gray-100">
      <div className="w-14 h-14 rounded-full bg-[#6B8F8A] flex items-center justify-center">
        <Icon className="w-7 h-7 text-white" strokeWidth={1.5} />
      </div>
      <h3 className="text-lg font-bold text-[#3a3a3a]">
        {title}
      </h3>
      <p className="text-sm text-[#6b7280] leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default FeatureCard;
